import React, { useState, useEffect } from "react";
import { useCart } from "../../Cart/cartContext";
import { Link, useLocation } from "react-router-dom";
import styles from "./styles.module.css";

const NAV_LINKS = [
  { label: "Shop All", to: "/shop" },
  { label: "Men", to: "/shop?gender=Men" },
  { label: "Women", to: "/shop?gender=Women" },
  { label: "New Arrivals", to: "/new-arrivals" },
  { label: "Collections", to: "/collections" },
  { label: "Upcycled", to: "/upcycle" },
  { label: "About", to: "/about" },
];

const HeaderComponent = ({ cartCount, variant = "overlay" }) => {
  const { cart } = useCart();
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const count = (cart && cart.length) || cartCount || 0;

  // Elevate / solidify the header once the user scrolls past the hero fold
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Lock body scroll while the drawer is open
  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  // Close the drawer on route change
  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const solid = variant === "solid" || scrolled;

  return (
    <>
      <header
        className={[
          styles.header,
          variant === "solid" ? styles.sticky : styles.overlay,
          solid ? styles.solid : "",
        ].join(" ")}
      >
        <div className={styles.inner}>
          <button
            type="button"
            className={styles.menuBtn}
            aria-label="Open menu"
            aria-expanded={open}
            onClick={() => setOpen(true)}
          >
            <span />
            <span />
            <span />
          </button>

          <Link className={styles.logo} to="/">
            LORMAMI
          </Link>

          <Link
            to="/cart"
            className={styles.cart}
            aria-label={`Cart, ${count} item${count === 1 ? "" : "s"}`}
          >
            <svg
              width="22"
              height="22"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.6"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z" />
              <path d="M3 6h18" />
              <path d="M16 10a4 4 0 0 1-8 0" />
            </svg>
            {count > 0 && <span className={styles.badge}>{count}</span>}
          </Link>
        </div>
      </header>

      {/* Slide-in mobile / nav drawer */}
      <div
        className={[styles.scrim, open ? styles.scrimOpen : ""].join(" ")}
        onClick={() => setOpen(false)}
        aria-hidden="true"
      />
      <aside
        className={[styles.drawer, open ? styles.drawerOpen : ""].join(" ")}
        aria-hidden={!open}
      >
        <div className={styles.drawerHead}>
          <span className={styles.drawerBrand}>LORMAMI</span>
          <button
            type="button"
            className={styles.closeBtn}
            aria-label="Close menu"
            onClick={() => setOpen(false)}
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.6"
              strokeLinecap="round"
              aria-hidden="true"
            >
              <path d="M18 6 6 18M6 6l12 12" />
            </svg>
          </button>
        </div>

        <nav className={styles.nav}>
          {NAV_LINKS.map((link, i) => (
            <Link
              key={link.to}
              to={link.to}
              className={styles.navLink}
              onClick={() => setOpen(false)}
              style={{ transitionDelay: open ? `${0.08 * i + 0.12}s` : "0s" }}
            >
              <span>{link.label}</span>
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
              >
                <path d="m9 18 6-6-6-6" />
              </svg>
            </Link>
          ))}
        </nav>

        <div className={styles.drawerFoot}>
          <Link
            to="/cart"
            className={styles.drawerCart}
            onClick={() => setOpen(false)}
          >
            View Cart ({count})
          </Link>
          <p className={styles.drawerNote}>Free shipping on orders over ₦100,000</p>
        </div>
      </aside>
    </>
  );
};

export default HeaderComponent;
